import { actionTypes } from './actionTypes';
import projects from './projects';
import login from './login';
import common from './common';
import analysis from './analysis';
import insights from './insights';
import insightModal from './insightModal';
import question from './question';
import systemSettings from './systemSettings';
import powerBIRefresh from './powerBIRefresh';
import activeSessions from './activeSessions';

export default Object.assign(
  {
    actionTypes,
  },
  projects,
  login,
  common,
  analysis,
  insights,
  insightModal,
  question,
  systemSettings,
  powerBIRefresh,
  activeSessions,
);
